// Channel Actions - ES2015 Module Syntax
import { Channel, ChannelFilter, ChannelStats, InternalNote } from '../../models/chat.models';

// Load Actions
export class LoadChannels {
    static readonly type = '[Channel] Load Channels';
    constructor(public userId: string) {}
}

export class LoadChannelsSuccess {
    static readonly type = '[Channel] Load Channels Success';
    constructor(public channels: Channel[]) {}
}

export class LoadChannelsError {
    static readonly type = '[Channel] Load Channels Error';
    constructor(public error: any) {}
}

export class LoadAllChannels {
    static readonly type = '[Channel] Load All Channels';
    constructor(
        public limit?: number,
        public nextToken?: string,
        public sortBy?: string,
        public sortOrder?: 'asc' | 'desc',
        public filter?: ChannelFilter,
    ) {}
}

export class SetChannelSort {
    static readonly type = '[Channel] Set Sort';
    constructor(
        public sortBy: string,
        public sortOrder: 'asc' | 'desc',
        public filter?: ChannelFilter,
        public limit?: number,
    ) {}
}

export class LoadAllChannelsSuccess {
    static readonly type = '[Channel] Load All Channels Success';
    constructor(
        public channelConnection: { items: Channel[]; nextToken?: string },
        public requestNextToken?: string,
    ) {}
}

export class LoadAllChannelsError {
    static readonly type = '[Channel] Load All Channels Error';
    constructor(public error: any) {}
}

// CRUD Actions
export class AddChannel {
    static readonly type = '[Channel] Add Channel';
    constructor(public channel: Channel) {}
}

export class UpdateChannel {
    static readonly type = '[Channel] Update Channel';
    constructor(public channel: Channel) {}
}

export class UpdateOneChannel {
    static readonly type = '[Channel] Update One Channel';
    constructor(
        public channelId: string,
        public name?: string,
        public status?: string,
        public description?: string,
        public senderAvatar?: string,
        public priority?: string,
    ) {}
}

export class RemoveChannel {
    static readonly type = '[Channel] Remove Channel';
    constructor(public channelId: string) {}
}

// Mutation Actions
export class CreateChannel {
    static readonly type = '[Channel] Create Channel';
    constructor(
        public name: string,
        public description: string,
        public type: string,
        public members: string[],
        public referenceNo: string,
        public iconName?: string,
    ) {}
}

export class JoinChannel {
    static readonly type = '[Channel] Join Channel';
    constructor(public channelId: string) {}
}

export class LeaveChannel {
    static readonly type = '[Channel] Leave Channel';
    constructor(public channelId: string) {}
}

// Utility Actions
export class ClearChannels {
    static readonly type = '[Channel] Clear Channels';
}

export class LoadChannelById {
    static readonly type = '[Channel] Load Channel By Id';
    constructor(public channelId: string) {}
}

export class LoadChannelByIdSuccess {
    static readonly type = '[Channel] Load Channel By Id Success';
    constructor(public channel: Channel) {}
}

export class LoadChannelByIdError {
    static readonly type = '[Channel] Load Channel By Id Error';
    constructor(public error: unknown) {}
}

export class AssignAgent {
    static readonly type = '[Channel] Assign Agent';
    constructor(public channelId: string, public agentId: string) {}
}

// Type-filtered channel actions
export class LoadChannelsByType {
    static readonly type = '[Channel] Load Channels By Type';
    constructor(
        public types: string[],
        public limit?: number,
        public nextToken?: string,
        public sortBy?: string,
        public sortOrder?: string,
    ) {}
}

export class LoadChannelsByTypeSuccess {
    static readonly type = '[Channel] Load Channels By Type Success';
    constructor(
        public channelConnection: { items: Channel[]; nextToken?: string },
        public requestNextToken?: string,
    ) {}
}

export class ClearFilteredChannels {
    static readonly type = '[Channel] Clear Filtered Channels';
}

// Stats Actions
export class LoadChannelStats {
    static readonly type = '[Channel] Load Channel Stats';
    constructor(public statuses?: string[], public serviceTypes?: string[]) {}
}

export class LoadChannelStatsSuccess {
    static readonly type = '[Channel] Load Channel Stats Success';
    constructor(public stats: ChannelStats) {}
}

// Global stats — always loaded without a statuses filter so toggle badges
// always reflect the true all-time active/closed/total counts.
// serviceTypes scopes to the agent's permitted channel types.
export class LoadGlobalChannelStats {
    static readonly type = '[Channel] Load Global Channel Stats';
    constructor(public serviceTypes?: string[]) {}
}

export class LoadGlobalChannelStatsSuccess {
    static readonly type = '[Channel] Load Global Channel Stats Success';
    constructor(public stats: ChannelStats) {}
}

// Internal Notes Actions
export class AddInternalNote {
    static readonly type = '[Channel] Add Internal Note';
    constructor(
        public channelId: string,
        public note: InternalNote,
    ) {}
}

export class DeleteInternalNote {
    static readonly type = '[Channel] Delete Internal Note';
    constructor(
        public channelId: string,
        public noteId: string,
    ) {}
}

// Selection Actions
export class SetSelectedChannel {
    static readonly type = '[Channel] Set Selected Channel';
    constructor(public channelId?: string) {}
}
